import { getCountryCodeToName } from 'constants/SignupFormConstants';

export const isCountryValid = (countryCode: string): boolean => {
  return countryCode in getCountryCodeToName();
};
